<template>
  <svg viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.523438 9.69531L1.26562 10.4766C1.46094 10.6719 1.77344 10.6719 1.92969 10.4766L7.98438 4.42188V17.7812C7.98438 18.0156 8.21875 18.25 8.45312 18.25H9.54688C9.82031 18.25 10.0156 18.0156 10.0156 17.7812V4.42188L16.1094 10.4766C16.2656 10.6719 16.5781 10.6719 16.7734 10.4766L17.5156 9.69531C17.7109 9.53906 17.7109 9.22656 17.5156 9.03125L9.35156 0.867188C9.15625 0.671875 8.88281 0.671875 8.6875 0.867188L0.523438 9.03125C0.328125 9.22656 0.328125 9.53906 0.523438 9.69531Z"
      fill="currentColor"
    />
  </svg>
</template>
